<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<v-btn color="primary" @click="addClick" class="mr-2">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;Nova Pretplata
				</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-card flat outlined>
					<v-card-text>
						<v-row>
							<v-col>
								<TheTable
									:additional-filters="subscriptionsTable.additionalFilters"
									:default-sort="subscriptionsTable.defaultSort"
									:excel="true"
									:fields="subscriptionsTable.headers"
									:header-selection-key="'subscriptions-headers'"
									:filter-save-key="'subscriptions-filters'"
									:height="subscriptionsTable.height"
									:total-records="subscriptionsTable.total"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in subscriptionsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="subscriptionsTable.selectedHeaders.includes('date')"
											@click="editClick(item.id, false)"
										>
											{{ item.date }}
										</td>
										<td
											v-if="subscriptionsTable.selectedHeaders.includes('magazine_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.magazine.name }}
										</td>
										<td
											v-if="subscriptionsTable.selectedHeaders.includes('title')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.title">{{item.title}}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="subscriptionsTable.selectedHeaders.includes('private_count')"
											@click="editClick(item.id, false)"
										>
											{{ item.private_count }}
										</td>
										<td
											v-if="subscriptionsTable.selectedHeaders.includes('branch_count')"
											@click="editClick(item.id, false)"
										>
											{{ item.branch_count }}
										</td>
										<td
											v-if="subscriptionsTable.selectedHeaders.includes('bookstore_count')"
											@click="editClick(item.id, false)"
										>
											{{ item.bookstore_count }}
										</td>
										<td
											v-if="subscriptionsTable.selectedHeaders.includes('total_count')"
											@click="editClick(item.id, false)"
										>
											{{ item.total_count }}
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Subscriptions',
	components: { TheTable },
	data: function () {
		return {
			subscriptionsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.date'), value: 'date', type: 'date', allowFilter: true },
					{
						text: this.$t('fields.magazine'),
						value: 'magazine_id',
						type: 'dropdown|magazines',
						allowFilter: true,
					},
					{
						text: this.$t('fields.subscriptionTitle'),
						value: 'title',
						type: 'string',
						allowFilter: true,
					},
					{
						text: this.$t('fields.subscriptionPrivate'),
						value: 'private_count',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.subscriptionBranch'),
						value: 'branch_count',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.subscriptionBookstore'),
						value: 'bookstore_count',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.subscriptionTotal'),
						value: 'total_count',
						type: '',
						allowFilter: true,
					},
				],
				additionalFilters: [
					{
						text: this.$t('fields.date'),
						value: 'date',
						type: 'date_range',
						allowFilter: true,
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/subscriptions/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/subscriptions/' + id);
			} else {
				let routeData = this.$router.resolve('/subscriptions/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.subscriptionsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.subscriptionsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'subscriptions',
				request,
				(data, success) => {
					if (success) {
						vm.subscriptionsTable.items = data.items;
						vm.subscriptionsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.subscriptionsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'subscriptions',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/subscriptions', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolveWindowResize() {
			this.subscriptionsTable.height = window.innerHeight - 310 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.subscriptions'), href: '/#/subscriptions', disabled: true },
		]);
		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
